(() => {
  const P = (window.LP_PRICING = window.LP_PRICING || {});
  const LP = (window.LPB2G1 = window.LPB2G1 || {});
  const format = amount => String(P.moneyFormat || '${{amount}}').replace(/\{\{\s*\w+\s*\}\}/, amount);

  LP.money = cents => {
    if (cents === null || cents === undefined || Number.isNaN(Number(cents))) return '';
    return format((Math.round(cents) / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
  };

  LP.moneyWhole = cents => {
    if (cents === null || cents === undefined || Number.isNaN(Number(cents))) return '';
    return format(Math.floor(cents / 100).toLocaleString('en-US', { maximumFractionDigits: 0 }));
  };

  LP.fill = (template, vars) =>
    String(template || '').replace(/\{(\w+)\}/g, (m, k) => (Object.prototype.hasOwnProperty.call(vars, k) ? vars[k] : m));

  LP.emit = (name, detail) => document.dispatchEvent(new CustomEvent(`lp-b2g1:${name}`, { detail: detail || {} }));

  // USD to the visitor's currency, from the bottle's local price against its US price
  LP.usdRate = () => {
    const usd = parseFloat(P.usdUnitPrice);
    const shades = P.shades || [];
    const s = shades.find(x => x.variantId && x.available !== false) || shades[0];
    const local = s && s.price != null ? Number(s.price) / 100 : NaN;
    return usd > 0 && local > 0 ? local / usd : null;
  };

  // Page copy quotes prices in USD ("$150 at the salon"). Outside USD, rewrite them in the visitor's
  // currency. Runs before any script renders its own prices, which are already local.
  const localizeCopy = () => {
    if (String(P.currency || 'USD').toUpperCase() === 'USD') return;
    const rate = LP.usdRate();
    if (!rate) return;
    // The lead character keeps prefixed local symbols (C$, A$, NZ$) out
    const re = /(^|[^A-Za-z$])\$(\d{1,3}(?:,\d{3})+|\d+)(\.\d{1,2})?/g;
    const walker = document.createTreeWalker(document.querySelector('main') || document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: n => (n.parentElement && n.parentElement.closest('script, style, template') ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT),
    });
    const hits = [];
    while (walker.nextNode()) if (/\$\d/.test(walker.currentNode.nodeValue)) hits.push(walker.currentNode);
    hits.forEach(node => {
      node.nodeValue = node.nodeValue.replace(re, (m, lead, whole, dec) => {
        const usd = parseFloat(whole.replace(/,/g, '') + (dec || ''));
        return lead + (dec ? LP.money(usd * rate * 100) : LP.moneyWhole(Math.round(usd * rate) * 100));
      });
    });
  };
  localizeCopy();

  const ISO_END = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?(Z|[+-]\d{2}:\d{2})$/;
  const readEnd = () => {
    for (const el of document.querySelectorAll('[data-lp-salon-ends]')) {
      const v = (el.getAttribute('data-lp-salon-ends') || '').trim();
      if (!ISO_END.test(v)) continue;
      const t = Date.parse(v);
      if (!Number.isNaN(t)) return t;
    }
    return null;
  };
  P.endsAt = readEnd();

  const pad = n => (n < 10 ? `0${n}` : String(n));

  const loopEl = document.querySelector('[data-lp-salon-countdown][data-hours]');
  const loopSecs = loopEl
    ? (Number(loopEl.dataset.hours) || 0) * 3600 + (Number(loopEl.dataset.minutes) || 0) * 60 + (Number(loopEl.dataset.seconds) || 0)
    : 0;
  const loopFrom = Date.now();
  const loopUp = !!loopEl && loopEl.dataset.direction === 'up';
  const loopLeft = () => {
    const spent = Math.floor((Date.now() - loopFrom) / 1000);
    if (loopUp) return Math.min(loopSecs + spent, 359999);
    return loopSecs - (spent % loopSecs);
  };

  LP.tick = () => {
    let total;
    let live;
    if (P.endsAt) {
      total = Math.floor((P.endsAt - Date.now()) / 1000);
      live = total >= 1;
    } else if (loopUp) {
      total = loopLeft();
      live = true;
    } else {
      total = loopSecs > 0 ? loopLeft() : 0;
      live = total >= 1;
    }
    const parts = { h: pad(Math.floor(total / 3600)), m: pad(Math.floor((total % 3600) / 60)), s: pad(total % 60) };
    const show = (el, on) => {
      (el.closest('[data-lp-ends-wrap]') || el).hidden = !on;
    };
    document.querySelectorAll('[data-lp-salon-deadline], [data-lp-salon-countdown]').forEach(el => {
      const isLoop = el.hasAttribute('data-lp-salon-countdown');
      if (isLoop && !P.endsAt) {
        el.hidden = false;
      } else {
        show(el, live);
      }
      if (!live) return;
      if (el.getAttribute('data-format') === 'text') {
        el.textContent = `${parts.h}:${parts.m}:${parts.s}`;
        return;
      }
      Object.keys(parts).forEach(k => {
        const d = el.querySelector(`[data-unit="${k}"]`);
        if (d) d.textContent = parts[k];
      });
    });
    return live;
  };

  if (LP.tick()) {
    const timer = setInterval(() => {
      if (!LP.tick()) clearInterval(timer);
    }, 1000);
  }
})();
(() => {
  document.querySelectorAll('[data-lp-tabs]').forEach(root => {
    const tabs = [...root.querySelectorAll('[role="tab"]')];
    const select = (i, focus) => {
      tabs.forEach((t, j) => {
        const on = i === j;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
        const panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tabs[i].focus();
    };
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => select(i));
      t.addEventListener('keydown', e => {
        const step = { ArrowRight: 1, ArrowLeft: -1 }[e.key];
        if (!step) return;
        e.preventDefault();
        select((i + step + tabs.length) % tabs.length, true);
      });
    });
  });
})();
(() => {
  const box = document.querySelector('[data-lp-box]');
  const LP = window.LPB2G1;
  const P = window.LP_PRICING;
  if (!box || !LP) return;
  const shades = P.shades || [];
  const $ = (sel, el = box) => el.querySelector(sel);
  const $$ = (sel, el = box) => [...el.querySelectorAll(sel)];

  LP.state = { tier: 'one', shade: shades.length ? shades[0].key : null };
  LP.shadeBy = key => shades.find(x => x.key === key) || null;
  LP.sellable = x => !!(x && x.variantId && x.available !== false);
  LP.tableCents = text => {
    const cur = String(P.currency || '').toUpperCase();
    const lines = String(text || '').split(/\r?\n/).map(l => l.trim().split(/\s+/)).filter(l => l.length >= 2);
    const hit = lines.find(l => l[0].toUpperCase() === cur) || lines.find(l => l[0] === '*');
    if (!hit) return null;
    const n = parseFloat(hit[1].replace(/[^0-9.]/g, ''));
    if (Number.isNaN(n)) return null;
    if ((hit[2] || '').toUpperCase() !== 'USD') return Math.round(n * 100);
    const rate = LP.usdRate();
    return rate ? Math.round(n * rate * 100) : null;
  };
  LP.shipCents = () => LP.tableCents(P.shipRates);
  LP.maskCents = () => {
    if (P.maskVariantId && P.maskPrice != null) return Number(P.maskPrice) || 0;
    return LP.tableCents(P.maskValues);
  };
  LP.tierEl = id => $(`[data-lp-tier="${id}"]`);
  const count = (raw, fallback) => {
    const v = Math.floor(Number(raw));
    return v >= 1 ? v : fallback;
  };
  LP.tierQty = id => {
    const el = LP.tierEl(id);
    return count(el && el.dataset.qty, id === 'b2g1' ? 3 : 1);
  };
  LP.tierPaid = id => {
    const el = LP.tierEl(id);
    return count(el && el.dataset.paid, id === 'b2g1' ? 2 : 1);
  };

  const unit = () => {
    const cur = LP.shadeBy(LP.state.shade);
    if (cur && cur.price != null) return cur;
    return shades.find(x => x.price != null) || {};
  };

  LP.tierPrice = id => {
    const u = unit();
    if (u.price == null) return null;
    const qty = LP.tierQty(id);
    const paid = LP.tierPaid(id);
    const price = u.price * paid;
    const compare = u.compareAt && u.compareAt > u.price ? u.compareAt * qty : null;
    const save = compare && compare > price ? compare - price : null;
    return { qty, paid, price, compare, save, perBottle: Math.round(price / qty) };
  };

  LP.valueFor = key => {
    if (key === 'bottle') {
      const u = unit();
      return u.price != null ? LP.money(u.price) : '';
    }
    if (key === 'mask') {
      const c = LP.maskCents();
      return c != null ? LP.money(c) : '';
    }
    if (key === 'ship') {
      const c = LP.shipCents();
      return c != null ? LP.money(c) : '';
    }
    return '';
  };

  LP.render = () => {
    const cur = LP.tierPrice(LP.state.tier) || {};
    $$('[data-lp-price="price"]').forEach(el => {
      el.textContent = LP.money(cur.price);
    });
    $$('[data-lp-price="compare"]').forEach(el => {
      el.textContent = cur.compare ? LP.money(cur.compare) : '';
      el.hidden = !cur.compare;
    });
    $$('[data-lp-tier]').forEach(card => {
      const id = card.dataset.lpTier;
      const t = LP.tierPrice(id) || {};
      const on = id === LP.state.tier;
      card.setAttribute('aria-checked', String(on));
      card.tabIndex = on ? 0 : -1;
      $('[data-lp-tier-price]', card).textContent = LP.money(t.price);
      const cmp = $('[data-lp-tier-compare]', card);
      cmp.textContent = t.compare ? LP.money(t.compare) : '';
      cmp.hidden = !t.compare;
      const save = $('[data-lp-tier-save]', card);
      save.textContent = t.save ? LP.fill(P.saveLabel, { amount: LP.moneyWhole(t.save) }) : '';
      save.hidden = !t.save;
      const sub = $('[data-lp-tier-sub]', card);
      if (sub) sub.textContent = t.perBottle ? LP.fill(sub.dataset.template, { per_bottle: LP.money(t.perBottle) }) : '';
      $$('[data-lp-value]', card).forEach(v => {
        const key = v.dataset.lpValue;
        let text = LP.valueFor(key);
        if (!text && key === 'ship' && card.dataset.struck !== 'true') text = P.shipOther || '';
        v.textContent = text;
        v.hidden = !text;
      });
    });
    const line = $('[data-lp-shipline]');
    if (line) line.textContent = LP.state.tier === 'b2g1' ? line.dataset.b2g1 : line.dataset.one;
    const use = cur.price != null && P.uses ? LP.money(Math.round(cur.price / cur.qty / P.uses)) : '';
    $$('[data-lp-peruse]').forEach(el => {
      el.textContent = LP.fill(el.dataset.template, { per_use: use });
    });
    $$('[data-lp-peruse-aria]').forEach(el => el.setAttribute('aria-label', LP.fill(el.dataset.template, { per_use: use })));
    $$('[data-lp-peruse-open]').forEach(el => {
      el.hidden = !use;
    });
    const box = LP.tableCents(P.boxCosts);
    $$('[data-lp-box-cost]').forEach(el => {
      el.textContent = box != null ? LP.moneyWhole(Math.round(box / 100) * 100) : '';
    });
    $$('[data-lp-sheet-cost]').forEach(el => {
      el.hidden = box == null || !use;
    });
  };

  const track = $('[data-lp-gallery]');
  const slides = $$('[data-lp-slide]');
  const dots = $('[data-lp-dots]');
  const prev = $('[data-lp-gprev]');
  const next = $('[data-lp-gnext]');
  const VIDEO = 3;
  let shown = -1;

  const ensureImg = (holder, cls, size) => {
    let img = $('img', holder);
    if (!img) {
      img = document.createElement('img');
      if (cls) img.className = cls;
      img.width = size;
      img.height = size;
      img.loading = 'lazy';
      img.decoding = 'async';
      img.alt = '';
      holder.insertBefore(img, holder.firstChild);
    }
    return img;
  };

  const ensureVideo = holder => {
    let v = $('video', holder);
    if (!v) {
      v = document.createElement('video');
      v.className = 'lp-b2g1-gallery__img';
      v.muted = true;
      v.loop = true;
      v.playsInline = true;
      v.preload = 'none';
      v.width = 700;
      v.height = 700;
      holder.insertBefore(v, holder.firstChild);
    }
    return v;
  };

  const setSrc = (img, src) => {
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = src;
  };

  const live = () => slides.filter(sl => !sl.hidden);
  const at = () => (track ? Math.round(track.scrollLeft / (track.clientWidth || 1)) : 0);

  const sync = () => {
    const list = live();
    const i = Math.max(0, Math.min(list.length - 1, at()));
    $$('span', dots).forEach((d, j) => d.classList.toggle('on', j === i));
    if (i !== shown) {
      shown = i;
      list.forEach((sl, j) => {
        const v = $('video', sl);
        if (!v) return;
        if (j === i) {
          v.preload = 'auto';
          v.play().catch(() => {});
        } else {
          v.pause();
        }
      });
    }
    if (prev) prev.disabled = i <= 0;
    if (next) next.disabled = i >= list.length - 1;
  };

  const go = i => {
    const n = live().length;
    if (track) track.scrollTo({ left: Math.max(0, Math.min(n - 1, i)) * track.clientWidth, behavior: 'smooth' });
  };

  const setGallery = s => {
    const alt = LP.fill(P.altTemplate, { shade: s.name });
    slides.forEach((slide, i) => {
      const src = (s.gallery || [])[i];
      slide.hidden = !src;
      if (!src) return;
      if (i === VIDEO) {
        const v = ensureVideo(slide);
        v.poster = s.poster || '';
        v.setAttribute('aria-label', alt);
        if (v.getAttribute('src') !== src) v.setAttribute('src', src);
        return;
      }
      const img = ensureImg(slide, 'lp-b2g1-gallery__img', 700);
      setSrc(img, src);
      img.alt = alt;
    });
    if (dots) {
      dots.textContent = '';
      live().forEach(() => dots.appendChild(document.createElement('span')));
    }
    if (track) track.scrollTo({ left: 0, behavior: 'instant' });
    shown = -1;
    sync();
    $$('[data-lp-band-bottle]').forEach(img => {
      if (s.packshot) img.src = s.packshot;
    });
  };

  if (track) {
    track.addEventListener('scroll', sync, { passive: true });
    track.addEventListener('keydown', e => {
      const step = { ArrowRight: 1, ArrowLeft: -1 }[e.key];
      if (!step) return;
      e.preventDefault();
      go(at() + step);
    });
  }
  if (prev) prev.addEventListener('click', () => go(at() - 1));
  if (next) next.addEventListener('click', () => go(at() + 1));
  sync();

  const sheet = $('[data-lp-sheet]');
  if (sheet) {
    let back = null;
    const shut = () => {
      sheet.hidden = true;
      document.documentElement.classList.remove('lp-b2g1-locked');
      if (back && back.focus) back.focus();
    };
    document.addEventListener('click', e => {
      if (e.target.closest('[data-lp-peruse-open]')) {
        back = document.activeElement;
        sheet.hidden = false;
        document.documentElement.classList.add('lp-b2g1-locked');
        $('[data-lp-sheet-close]').focus();
      } else if (!sheet.hidden && (e.target === sheet || e.target.closest('[data-lp-sheet-close]'))) {
        shut();
      }
    });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && !sheet.hidden) shut();
    });
  }

  LP.setShade = (key, opts = {}) => {
    const s = LP.shadeBy(key);
    if (!s) return;
    const changed = LP.state.shade !== key;
    LP.state.shade = key;
    $$('[data-lp-shade]').forEach(b => {
      const on = b.dataset.lpShade === key;
      b.setAttribute('aria-checked', String(on));
      b.tabIndex = on ? 0 : -1;
    });
    const name = $('[data-lp-shade-name]');
    if (name) name.textContent = s.name;
    setGallery(s);
    LP.render();
    if (opts.user && changed) LP.emit('shade', { shade: key });
  };

  LP.setTier = (id, opts = {}) => {
    if (!LP.tierEl(id)) return;
    const changed = LP.state.tier !== id;
    LP.state.tier = id;
    LP.render();
    if (opts.user && changed) LP.emit('tier', { tier: id });
  };

  const radioGroup = (group, selector, pick, activateKeys) => {
    if (!group) return;
    group.addEventListener('click', e => {
      const el = e.target.closest(selector);
      if (el && group.contains(el)) pick(el, false);
    });
    group.addEventListener('keydown', e => {
      const list = $$(selector, group);
      const i = list.indexOf(document.activeElement);
      if (i < 0) return;
      if (activateKeys && (e.key === ' ' || e.key === 'Enter')) {
        e.preventDefault();
        pick(list[i], true);
        return;
      }
      const step = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
      if (!step) return;
      e.preventDefault();
      pick(list[(i + step + list.length) % list.length], true);
    });
  };

  radioGroup(
    $('[data-lp-shades]'),
    '[data-lp-shade]',
    (el, focus) => {
      LP.setShade(el.dataset.lpShade, { user: true });
      if (focus) el.focus();
    },
    false
  );
  radioGroup(
    $('[data-lp-tiers]'),
    '[data-lp-tier]',
    (el, focus) => {
      LP.setTier(el.dataset.lpTier, { user: true });
      if (focus) el.focus();
    },
    true
  );

  LP.render();
})();
(() => {
  const root = document.querySelector('[data-lp-picker]');
  const LP = window.LPB2G1;
  const P = window.LP_PRICING;
  if (!root || !LP || !LP.state) return;
  const C = JSON.parse(root.querySelector('[data-lp-picker-config]').textContent);
  const shades = P.shades || [];
  const $ = sel => root.querySelector(sel);
  const $$ = sel => [...root.querySelectorAll(sel)];
  const list = $('[data-lp-picker-list]');
  const rewards = $$('[data-lp-reward]').map(el => ({ key: el.dataset.lpReward, at: Number(el.dataset.unlock) || 0 }));
  const esc = t => String(t == null ? '' : t).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
  const chev = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  let picks = [];
  let open = new Set();
  let lastFocus = null;
  let lastTotal = 0;
  let busy = false;
  let flipped = false;

  const tier = () => LP.state.tier;
  const isB2g1 = () => tier() === 'b2g1';
  const q = () => LP.tierQty('b2g1');
  const n = () => picks.length;
  const countOf = key => picks.filter(k => k === key).length;
  const unlocked = r => n() >= r.at;
  const grouped = arr => arr.reduce((m, k) => m.set(k, (m.get(k) || 0) + 1), new Map());
  const shadesParam = () => [...grouped(picks)].map(([k, c]) => `${k}:${c}`).join(',');
  const snapshot = () => ({ tier: tier(), bottles: n(), shades: shadesParam() });
  // Checkout's BUY 2 GET 1 FREE frees a shade that has a single bottle, or the last line when
  // every shade differs. Move that bottle to the end so the summary and the link agree with it.
  const ordered = () => {
    const out = picks.slice();
    if (n() < q() || q() - LP.tierPaid('b2g1') !== 1) return out;
    const g = grouped(out);
    const last = out[out.length - 1];
    const single = [...g].find(([, c]) => c === 1);
    const free = g.get(last) === 1 || !single ? last : single[0];
    out.splice(out.lastIndexOf(free), 1);
    out.push(free);
    return out;
  };

  const bold = text => esc(text).replace(/\*\*(.+?)\*\*/g, '<b>$1</b>');

  const figure = (src, label, name) =>
    src ? `<figure><img src="${esc(src)}" alt="${esc(`${name}, ${label}`)}" width="160" height="160" loading="lazy"><figcaption>${esc(label)}</figcaption></figure>` : '';

  const row = s => {
    const c = countOf(s.key);
    const isOpen = open.has(s.key);
    const plusOff = n() >= q() || !LP.sellable(s);
    const vars = { shade: s.name };
    return `<div class="lp-b2g1-row${c ? ' is-on' : ''}" data-key="${esc(s.key)}">
      <div class="lp-b2g1-row__main">
        ${s.packshot ? `<img class="lp-b2g1-row__pack" src="${esc(s.packshot)}" alt="" width="58" height="58" loading="lazy">` : ''}
        <p class="lp-b2g1-row__name">${esc(s.name)}</p>
        <div class="lp-b2g1-step" role="group" aria-label="${esc(LP.fill(C.qtyLabel, vars))}">
          <button type="button" data-act="minus" aria-label="${esc(LP.fill(C.minusLabel, vars))}"${c ? '' : ' disabled'}>&minus;</button>
          <output aria-live="polite">${c}</output>
          <button type="button" data-act="plus" aria-label="${esc(LP.fill(C.plusLabel, vars))}"${plusOff ? ' disabled' : ''}>+</button>
        </div>
        <button type="button" class="lp-b2g1-row__more" data-act="more" aria-expanded="${isOpen}" aria-label="${esc(LP.fill(isOpen ? C.lessLabel : C.moreLabel, vars))}">${chev}</button>
      </div>
      ${isOpen ? `<div class="lp-b2g1-row__detail">${figure(s.packshot, C.capProduct, s.name)}${figure(s.tone, C.capTone, s.name)}${figure(s.beforeAfter, s.key === C.capResultShade ? C.capResult : C.capBeforeAfter, s.name)}</div>` : ''}
    </div>`;
  };

  const line = (label, value, free) => `<p class="lp-b2g1-sum__row"><span>${esc(label)}</span><span${free ? ' class="is-free"' : ''}>${esc(value)}</span></p>`;

  const pricing = () => {
    const full = n() >= q();
    const paidN = full ? LP.tierPaid('b2g1') : n();
    let total = 0;
    let compare = 0;
    ordered().forEach((k, i) => {
      const s = LP.shadeBy(k);
      const price = s.price || 0;
      if (i < paidN) total += price;
      compare += s.compareAt && s.compareAt > price ? s.compareAt : price;
    });
    return { full, paidN, total, compare };
  };

  const maskCents = () => LP.maskCents() || 0;

  const summaryRows = () => {
    const { full, paidN, compare, total: base } = pricing();
    let total = base;
    const out = [];
    const order = ordered();
    grouped(order.slice(0, paidN)).forEach((c, k) => {
      const s = LP.shadeBy(k);
      out.push(line(LP.fill(C.lineShade, { shade: s.name, n: c }), LP.money((s.price || 0) * c)));
    });
    grouped(order.slice(paidN)).forEach((c, k) => {
      out.push(line(LP.fill(C.lineShade, { shade: LP.shadeBy(k).name, n: c }), C.free, true));
    });
    const lastAt = Math.max(0, ...rewards.map(r => r.at));
    if (full) {
      rewards.forEach(r => {
        if (r.key !== 'bottle' && unlocked(r)) out.push(line(r.key === 'mask' ? C.lineMask : C.lineShip, C.free, true));
      });
    } else if (!isB2g1() && n() === 1) {
      const ship = LP.shipCents();
      if (ship != null) {
        out.push(line(C.lineShip, LP.money(ship)));
        total += ship;
      } else if (P.shipOther) {
        out.push(line(C.lineShip, P.shipOther));
      }
    } else if (rewards.length && n() < lastAt) {
      out.push(`<p class="lp-b2g1-sum__note">${esc(LP.fill(C.lockedNote, { n: lastAt - n() }))}</p>`);
    }
    lastTotal = total;
    const struck = full && compare > total ? `<s>${esc(LP.money(compare))}</s> ` : '';
    out.push(`<p class="lp-b2g1-sum__total"><span>${esc(C.totalLabel)}</span><span>${struck}<strong>${esc(LP.money(total))}</strong></span></p>`);
    return out.join('');
  };

  const buttonState = () => {
    const c = n();
    const need = q();
    if (isB2g1() ? c >= need : c === 1 || c >= need) return { enabled: true, label: C.btnCheckout };
    if (c === 0) return { enabled: false, label: isB2g1() ? C.btnEmptyB2g1 : C.btnEmptyOne };
    if (c === need - 1) return { enabled: false, label: C.btnFree };
    return { enabled: false, label: LP.fill(C.btnAdd, { n: need - c }) };
  };

  const ord = d => d + (d % 10 === 1 && d !== 11 ? 'st' : d % 10 === 2 && d !== 12 ? 'nd' : d % 10 === 3 && d !== 13 ? 'rd' : 'th');
  const day = offset => {
    const d = new Date();
    d.setDate(d.getDate() + Number(offset || 0));
    return `<strong>${d.toLocaleDateString('en-US', { month: 'short' })} ${ord(d.getDate())}</strong>`;
  };

  const strip = () => {
    const steps = $$('.lp-b2g1-strip__steps li');
    let last = -1;
    steps.forEach((li, i) => {
      const on = n() >= Number(li.dataset.at);
      li.classList.toggle('on', on);
      if (on) last = i;
      if (i < 2 || li.dataset.lpReward === 'bottle') {
        const s = LP.shadeBy(picks[Math.min(i, 2)]) || LP.shadeBy(LP.state.shade) || shades[0];
        const img = li.querySelector('img');
        if (s && s.packshot && img && img.getAttribute('src') !== s.packshot) {
          img.srcset = '';
          img.src = s.packshot;
        }
      }
    });
    $('[data-lp-fill]').style.width = `${last > 0 ? (last / (steps.length - 1)) * 100 : 0}%`;
  };

  const render = () => {
    const c = n();
    const need = q();
    $('[data-lp-picker-title]').innerHTML = bold(C.titles[Math.min(c, 3)]);
    const mix = $('[data-lp-mix]');
    if (mix) {
      mix.textContent = LP.fill(C.mixLine, { max: need });
      mix.hidden = !isB2g1();
    }
    list.innerHTML = shades.map(row).join('');
    strip();
    const summary = $('[data-lp-summary]');
    summary.hidden = c === 0;
    $('[data-lp-summary-rows]').innerHTML = c ? summaryRows() : '';
    const st = buttonState();
    const { full, total, compare } = pricing();
    const saving = st.enabled ? compare - total + (full ? maskCents() + (LP.shipCents() || 0) : 0) : 0;
    $('[data-lp-status]').textContent = !c
      ? C.statusEmpty
      : st.enabled
        ? saving > 0
          ? LP.fill(C.statusSave, { amount: LP.money(saving) })
          : ''
        : c === need - 1
          ? C.statusFree
          : LP.fill(C.statusMore, { n: need - c });
    $('[data-lp-hint]').textContent = c >= need ? C.hintAll : c === need - 1 ? C.hintTwo : c ? C.hintOne : '';
    const btn = $('[data-lp-checkout]');
    const label = $('[data-lp-checkout-label]');
    const price = $('[data-lp-cta-price]');
    label.textContent = st.label;
    btn.setAttribute('aria-disabled', String(!st.enabled));
    btn.classList.toggle('is-ready', st.enabled);
    price.hidden = !st.enabled;
    if (st.enabled) {
      const struck = price.querySelector('s');
      struck.hidden = !(compare > total);
      struck.textContent = LP.money(compare);
      price.querySelector('strong').textContent = LP.money(total);
    }
    if (st.enabled && !root.hidden) {
      const arrow = $('.lp-b2g1-picker__arrow').getBoundingClientRect();
      const lead = label.getBoundingClientRect().left < btn.getBoundingClientRect().left + 8;
      if (price.getBoundingClientRect().right > arrow.left - 1 || lead) label.textContent = C.btnShort;
    }
    $('[data-lp-eta]').innerHTML = LP.fill(esc(C.eta), { from: day(C.etaFrom), to: day(C.etaTo) });
  };

  const toastEl = $('[data-lp-toast]');
  let toastTimer = 0;
  const clearToast = () => {
    clearTimeout(toastTimer);
    toastEl.classList.remove('show');
    toastEl.textContent = '';
  };
  const toast = text => {
    clearTimeout(toastTimer);
    toastEl.textContent = text;
    toastEl.classList.remove('show');
    void toastEl.offsetWidth;
    toastEl.classList.add('show');
    toastTimer = setTimeout(clearToast, 2400);
  };
  toastEl.addEventListener('animationend', clearToast);

  const trkParams = url => {
    const T = window.__trk;
    if (!T || typeof T.collect !== 'function') return;
    if (T.atcEv === undefined) T.atcEv = Math.round(performance.now());
    const a = T.collect();
    Object.keys(a).forEach(k => url.searchParams.set(`attributes[${k}]`, a[k]));
  };

  LP.permalink = commit => {
    const lines = [];
    grouped(ordered()).forEach((c, k) => {
      const s = LP.shadeBy(k);
      if (LP.sellable(s)) lines.push(`${s.variantId}:${c}`);
    });
    const maskReward = rewards.find(r => r.key === 'mask');
    if (P.maskVariantId && maskReward && unlocked(maskReward)) lines.push(`${P.maskVariantId}:1`);
    const url = new URL(`/cart/${lines.join(',')}`, window.location.origin);
    new URLSearchParams(window.location.search).forEach((v, k) => {
      if (/^utm_|^fbclid$/.test(k)) url.searchParams.set(k, v);
    });
    if (commit) trkParams(url);
    return url.toString();
  };

  list.addEventListener('click', e => {
    const b = e.target.closest('button');
    if (!b || b.disabled) return;
    const key = b.closest('[data-key]').dataset.key;
    const act = b.dataset.act;
    if (act === 'plus') {
      if (n() >= q() || !LP.sellable(LP.shadeBy(key))) return;
      picks.push(key);
      if (n() === q() && !isB2g1()) {
        flipped = true;
        LP.setTier('b2g1', { user: false });
      }
      if (n() === q() - 1) toast(C.toastTwo);
      else if (n() === q()) toast(C.toastThree);
    } else if (act === 'minus') {
      const i = picks.lastIndexOf(key);
      if (i < 0) return;
      picks.splice(i, 1);
      if (flipped && n() < q()) {
        flipped = false;
        LP.setTier('one', { user: false });
      }
    } else if (act === 'more') {
      if (open.has(key)) open.delete(key);
      else open.add(key);
    } else {
      return;
    }
    render();
    if (act !== 'more') LP.emit('picker-change', snapshot());
    const again = list.querySelector(`[data-key="${key}"] [data-act="${act}"]`);
    (again && !again.disabled ? again : list.querySelector(`[data-key="${key}"] [data-act="more"]`)).focus();
  });

  $('[data-lp-checkout]').addEventListener('click', () => {
    if (busy || !buttonState().enabled) return;
    busy = true;
    const url = LP.permalink(true);
    LP.emit('checkout', { ...snapshot(), total: Math.round(lastTotal) / 100 });
    window.location.assign(url);
  });

  LP.openPicker = () => {
    lastFocus = document.activeElement;
    picks = [];
    flipped = false;
    open = new Set(shades.some(s => s.key === C.defaultOpen) ? [C.defaultOpen] : []);
    clearToast();
    root.hidden = false;
    render();
    document.documentElement.classList.add('lp-b2g1-locked');
    $('[data-lp-picker-back]').focus();
    LP.emit('picker-open', { tier: tier() });
  };

  LP.closePicker = () => {
    if (root.hidden) return;
    root.hidden = true;
    picks = [];
    busy = false;
    flipped = false;
    clearToast();
    document.documentElement.classList.remove('lp-b2g1-locked');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  };

  window.addEventListener('pageshow', e => {
    busy = false;
    if (e.persisted && !root.hidden) render();
  });

  document.addEventListener('click', e => {
    if (e.target.closest('[data-lp-open-picker]')) LP.openPicker();
  });
  $$('[data-lp-picker-close]').forEach(el => el.addEventListener('click', LP.closePicker));

  document.addEventListener('keydown', e => {
    if (root.hidden) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      LP.closePicker();
      return;
    }
    if (e.key !== 'Tab') return;
    const focusable = $$('button:not([disabled]), [href], [tabindex]:not([tabindex="-1"])').filter(el => el.offsetParent !== null);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (!root.contains(document.activeElement)) {
      e.preventDefault();
      first.focus();
    } else if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });
})();
(() => {
  const near = (el, fn, margin) => {
    if (!el) return;
    if (!('IntersectionObserver' in window)) {
      fn();
      return;
    }
    const io = new IntersectionObserver(
      entries => {
        if (entries.some(e => e.isIntersecting)) {
          io.disconnect();
          fn();
        }
      },
      { rootMargin: `${margin}px 0px` }
    );
    io.observe(el);
  };

  document.querySelectorAll('[data-lp-vids]').forEach(sec => {
    const track = sec.querySelector('[data-lp-vids-track]');
    const cards = [...track.querySelectorAll('.lp-b2g1-vid')];
    const vids = cards.map(c => c.querySelector('video'));
    near(
      sec,
      () =>
        vids.forEach(v => {
          if (v.dataset.poster && !v.getAttribute('poster')) v.setAttribute('poster', v.dataset.poster);
        }),
      600
    );
    cards.forEach((card, i) => {
      const v = vids[i];
      card.querySelector('.lp-b2g1-vid__play').addEventListener('click', () => {
        vids.forEach((o, j) => {
          if (o !== v) {
            o.pause();
            o.controls = false;
            cards[j].classList.remove('is-started');
          }
        });
        v.controls = true;
        card.classList.add('is-started');
        const playing = v.play();
        if (playing && playing.catch) playing.catch(() => {});
        v.focus({ preventScroll: true });
      });
    });
    const step = () => (cards[0] ? cards[0].getBoundingClientRect().width + 12 : 240);
    sec.querySelector('[data-lp-vids-prev]').addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    sec.querySelector('[data-lp-vids-next]').addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
  });

  const faq = document.querySelector('.lp-salon-faq');
  if (faq && !document.getElementById('faq')) faq.id = 'faq';

  const loox = document.querySelector('[data-lp-loox]');
  if (loox) {
    let loaded = false;
    const load = () => {
      if (loaded) return;
      loaded = true;
      if (document.querySelector('script[src*="loox.io/widget/"]')) return;
      const s = document.createElement('script');
      s.src = loox.dataset.lpLoox;
      s.async = true;
      document.body.appendChild(s);
    };
    near(loox.closest('.lp-b2g1-reviews') || loox, load, 800);
    document.addEventListener('click', e => {
      if (e.target.closest('a[href="#looxReviews"]')) load();
    });
  }
})();

(() => {
  const push = o => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(o);
  };
  const names = {
    tier: 'lp_tier_select',
    shade: 'lp_shade_preview',
    'picker-open': 'lp_picker_open',
    'picker-change': 'lp_picker_change',
    checkout: 'lp_checkout_click',
  };
  Object.keys(names).forEach(k => document.addEventListener(`lp-b2g1:${k}`, e => push({ event: names[k], ...e.detail })));

  document.addEventListener(
    'click',
    e => {
      const t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('.lp-salon-sticky-cta__btn')) push({ event: 'lp_sticky_click' });
      else if (t.closest('.lp-b2g1-offer__btn')) push({ event: 'lp_offer_cta_click' });
    },
    true
  );

  const onOpen = (selector, labelSelector, event, key) =>
    document.querySelectorAll(selector).forEach(d =>
      d.addEventListener('toggle', () => {
        if (!d.open) return;
        const label = d.querySelector(labelSelector);
        push({ event, [key]: (label ? label.textContent : '').trim() });
      })
    );
  onOpen('.lp-salon-faq__item', '.lp-salon-faq__question-text', 'lp_faq_open', 'question');
  onOpen('[data-lp-accordion]', '.lp-b2g1-acc__q span', 'lp_accordion_open', 'title');
})();
(() => {
  const cta = document.querySelector('.lp-salon-sticky-cta');
  const first = document.querySelector('[id$="__reason-1"]');
  const shop = document.getElementById('shop');
  const videos = document.querySelector('[id$="__videos"]');
  const bar = document.querySelector('.lp-salon-bar__main');
  if (bar) bar.tabIndex = -1;
  if (!cta || !first || !('IntersectionObserver' in window)) {
    if (cta) cta.classList.add('is-on');
    return;
  }
  const end = document.createElement('div');
  end.style.cssText = 'display:block;height:1px;margin-top:-1px';
  end.setAttribute('aria-hidden', 'true');
  if (videos) (videos.closest('.shopify-section') || videos).after(end);
  const update = () => {
    const vh = window.innerHeight;
    const started = first.getBoundingClientRect().top <= 0;
    const box = shop ? shop.getBoundingClientRect() : null;
    const shopOn = !!box && box.top < vh && box.bottom > 0;
    const shopAbove = !!box && box.bottom <= 0;
    const past = !videos || end.getBoundingClientRect().top < vh - 120;
    cta.classList.toggle('is-on', started && !(shopOn || (shopAbove && !past)));
  };
  const watch = (el, margin) => el && new IntersectionObserver(update, { rootMargin: margin }).observe(el);
  watch(first, '0px 0px -100% 0px');
  watch(shop, '0px');
  watch(videos && end, '0px 0px -120px 0px');
  window.addEventListener('scrollend', update);
  update();
})();
(() => {
  const root = document.querySelector('[data-lp-tabs]');
  if (!root || !('IntersectionObserver' in window)) return;
  const io = new IntersectionObserver(entries => {
    if (!entries.some(e => e.isIntersecting)) return;
    io.disconnect();
    root.querySelectorAll('[role="tabpanel"] img').forEach(img => {
      img.loading = 'eager';
      const pre = new Image();
      pre.src = img.currentSrc || img.src;
    });
  }, { rootMargin: '600px 0px' });
  io.observe(root);
})();
(() => {
  const LP = window.LPB2G1;
  if (!LP || !LP.shipCents) return;
  const c = LP.shipCents();
  document.querySelectorAll('[data-lp-ship-line]').forEach(el => {
    if (c == null) el.remove();
    else el.textContent = el.textContent.replace('{ship}', LP.money(c));
  });
})();
